import React, { Component } from "react"
import './assets/css/bootstrap.min.css';
import './assets/css/feather.css';
import './assets/css/style.css';
import LoginPage from "./views/Login/LoginPage/LoginPage"
import Profile from "./views/Profile/Profile"
import Main from "./views/Main/Main"
import PlayList from "./views/PlayList/List"
import PlayListDetail from "./views/PlayList/Detail"
import CourseList from "./views/Course/List"
import CourseDetail from "./views/Course/Detail"
import FavoriteList from "./views/Favorite/Favorite"
import Util from "./utils/utils";
import {
	BrowserRouter as Router,
	Switch,
	Route
} from "react-router-dom";
import Header from "./components/layout/header";
import Footer from "./components/layout/footer";
import ScrollToTop from "./components/layout/util/scrollToTop";

class App extends Component
{
	componentDidMount (): void {
		Util.convertNumberToPersion();
	}

	componentDidUpdate ( prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS ): void {
		Util.convertNumberToPersion();
	}

	render ()
	{
		return (
			<Router>
				<Header/>
				<Switch>
					<Route exact path="/login">
						<LoginPage/>
					</Route>
					<Route exact path="/email-login">
						<LoginPage/>
					</Route>
					<Route exact path="/verify">
						<LoginPage/>
					</Route>
					<Route exact path="/profile" component={Profile} />
					<Route exact path="/" component={Main} />
					<Route exact path="/playlist" component={PlayList}/>
					<Route exact path="/playlist/:id" component={PlayListDetail}/>
					<Route exact path="/course/:id" component={CourseList}/>
					<Route exact path="/course/detail/:id" component={CourseDetail}/>
					<Route exact path="/favorite" component={FavoriteList}/>
				</Switch>
				<ScrollToTop/>
				<Footer/>
			</Router>
		);

	}
}

export default App;